module.exports = __webpack_public_path__ + "media/images/deduction_categories-4c492301.svg";